import { Box, Container, Grid, Header } from '@amzn/awsui-components-core';
import React from 'react';
export default () => {
  return (
    <Box padding={{ top: 'xxl', bottom: 'm', horizontal: 'l' }}>
      <Grid gridDefinition={[{ colspan: 10, offset: { m: 1 } }]}>
        <Container disableContentPaddings header={<Header variant="h3">Not Authorized</Header>}>
          <Box padding={'xl'} variant="p">
            Sorry, you are not authorized to access this page
          </Box>
        </Container>
      </Grid>
    </Box>
  );
};
